import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { Dayjs } from "dayjs";

class UpdateSelectedRangeAction extends BaseAction<void, [Dayjs | null, Dayjs | null]> {

    override async run(): Promise<void> {
        updateRecoilState("selectedRangeStateAtom", this.params);
    }
}

export const updateSelectedRangeAction = new UpdateSelectedRangeAction()


